module.exports = __webpack_public_path__ + "static/media/sumbki.08b5e500.png";